var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.title))]),_c('b-progress',{attrs:{"max":"100","show-progress":"","animated":"","value":_vm.progression,"variant":_vm.variant}}),_c('div',{staticClass:"mt-1"},[_vm._v(" "+_vm._s(_vm.description)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }